// extracted by mini-css-extract-plugin
export var background = "layouts-__FlatWhiteLayout-module___background";
export var bodyContainer = "layouts-__FlatWhiteLayout-module___bodyContainer";
export var fullWidthBody = "layouts-__FlatWhiteLayout-module___fullWidthBody";
export var header = "layouts-__FlatWhiteLayout-module___header";
export var headerBackground = "layouts-__FlatWhiteLayout-module___headerBackground";
export var pageHeader = "layouts-__FlatWhiteLayout-module___pageHeader";
export var subHeader = "layouts-__FlatWhiteLayout-module___subHeader";
export var title = "layouts-__FlatWhiteLayout-module___title";